module.exports = "/shared/fonts/tutorial-bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/tutorial-bold.ttf
// module id = 26
// module chunks = 13